<template>
  <fragment>
    <div :class="['sidepanel-ov', { 'sidepanel-ov--active': active }]" />
    <div :class="['sidepanel', { 'sidepanel--active': active }]">
      <div class="sidepanel__header">
        <div class="sidepanel__close">
          <b-button
            icon-right="close"
            inverted
            type="is-primary"
            @click="$emit('close')"
          />
        </div>
        <div class="sidepanel__title">
          <slot name="title" />
        </div>
        <div class="sidepanel__actions">
          <slot name="actions" />
        </div>
      </div>
      <div class="sidepanel__body">
        <slot />
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  props: {
    active: Boolean
  }
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.sidepanel-ov {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: $overlay-background;
  z-index: $sidepanel-z;
  display: none;

  &--active {
    display: block;
    animation-name: fadeIn;
    animation-duration: 180ms;
    animation-direction: alternate;
  }
}

.sidepanel {
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  transform: translateX(100%) translate3d(0, 0, 0);
  transition: 360ms;
  display: flex;
  flex-direction: column;
  background-color: $app-base-background;
  z-index: $sidepanel-z;

  &--active {
    box-shadow: $sidepanel-shadow;
    transition-delay: 240ms;
    transform: translateX(0) translate3d(0, 0, 0);
  }

  &__header {
    flex: 0 0 0;
    display: flex;
    align-items: center;
    height: $app-header-height;
    background-color: $app-header-background;
    box-shadow: $light-background-shadow;
    padding: 0.5rem 1rem;
  }

  &__title {
    flex: 1 0 0;
    margin: 0 1rem;
  }

  &__actions {
    display: flex;
    align-items: center;

    /deep/ .action {
      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }

  &__body {
    position: relative;
    flex: 1 0 0;
    overflow-y: auto;
  }
}
</style>
